import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, Space } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const handleLanguageChange = ({ key }) => {
    i18n.changeLanguage(key);
  };

  const getCurrentLanguageLabel = () => {
    switch (i18n.language) {
      case 'zh-CN':
        return t('language.chinese');
      case 'zh-HK':
        return t('language.traditional');
      case 'en-US':
        return t('language.english');
      default:
        return t('language.chinese');
    }
  };

  const items = [
    {
      key: 'zh-CN',
      label: t('language.chinese'),
    },
    {
      key: 'zh-HK',
      label: t('language.traditional'),
    },
    {
      key: 'en-US',
      label: t('language.english'),
    },
  ];

  return (
    <Dropdown
      menu={{
        items,
        selectedKeys: [i18n.language],
        onClick: handleLanguageChange,
      }}
      placement="bottomRight"
      trigger={['click']}
    >
      <Space
        style={{
          cursor: 'pointer',
          padding: '4px 10px',
          borderRadius: '6px',
          transition: 'all 0.2s ease',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(24, 144, 255, 0.15)',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.08)',
          height: '32px',
        }}
        className="language-switcher"
      >
        <GlobalOutlined
          style={{
            fontSize: '12px',
            color: '#1890ff',
          }}
        />
        <span style={{
          color: '#262626',
          fontSize: '12px',
          fontWeight: '500',
          userSelect: 'none',
          lineHeight: '20px',
        }}>
          {getCurrentLanguageLabel()}
        </span>
      </Space>
    </Dropdown>
  );
};

export default LanguageSwitcher;